const News = () => {
    return <h1>This page is under construction.</h1>;
  };
  
  export default News;